import { useEffect, useState } from "react";
import axiosInstance from "../interceptors";

// Resolve whether the current user is an admin (sees admin-only nav) vs a
// regular member (Organization_User). Uses the authoritative
// /common/user/get-user-type endpoint (resolved from master). Cached at module
// scope + de-duped so the sidebar / top bar / command palette share one lookup.
//
// While unknown (loading), returns null — callers should treat null as "not yet
// admin" so admin-only options never flash for a regular member. On a resolution
// error we fail OPEN (admin=true) so a transient hiccup never strands an admin.

let cached = null; // null = unknown, true/false once resolved
let inflight = null;

async function resolveIsAdmin() {
  if (cached !== null) return cached;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        cached = true; // no user context — don't hide anything
        return cached;
      }
      const r = await axiosInstance.post("/common/user/get-user-type", {
        id: userId,
      });
      const type = (r.data || "").toString();
      cached = type !== "Organization_User";
    } catch {
      cached = true; // fail open — never strand an admin on a transient error
    }
    return cached;
  })();
  return inflight;
}

export default function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(cached);
  useEffect(() => {
    let mounted = true;
    resolveIsAdmin().then((v) => {
      if (mounted) setIsAdmin(v);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return isAdmin; // null while loading, then true/false
}